// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".searchbox-badge-skeleton .v-skeleton-loader__avatar{width:24px;height:24px}.icon__interesado--searchBox{font-size:2.5rem!important}.icon__seguidor--searchBox{font-size:2rem!important;margin-left:.2rem}", ""]);
// Exports
module.exports = exports;
